import type {TemplateNode} from '@/uptk/core/components/moduleEntity/template/templateTypes';
export type CandidateReview={path:(string|number)[];category:'business'|'structure';reason:'number'|'identity'|'account'|'record'|'geometry'|'chart'|'repeat'|'directive'|'fixed';sample:string};
/** Review is deliberately separate from binding: a value is never matched by its amount. */
export function reviewPrototypeCandidates(root:TemplateNode,messages:Record<string,Record<string,string>>={}):CandidateReview[]{
 const result:CandidateReview[]=[];
 const text=(node:TemplateNode)=>node.type==='text'?(node.i18n?messages[node.i18n]?.fr??'':node.token??''):'';
 const walk=(node:TemplateNode,path:(string|number)[],avatar=false,record=false,total=false)=>{
  if(node.type==='text'){
   const sample=text(node).trim();
   const identity=/\b[Ff]oyer\s+\p{Lu}[\p{L}-]+/u.test(sample)||avatar&&/^[\p{Lu}]{1,3}$/u.test(sample);
   const account=/\b[A-Z]{2}\d{2}[ A-Z0-9]{11,32}\b|\b(?:IBAN|AVS)\b/i.test(sample);
   // Versions, static step numbers and punctuation are structural. Every other
   // numeric text stays reviewable, including dates, percentages and projections.
   const number=/\d/.test(sample)&&!/(?:prototype|version)\s+\d/i.test(sample)&&!/^\d+[.)]$/.test(sample);
   const data=record&&!!sample;
   if(node.candidate||identity||account||number||data)result.push({path,category:identity||account||number||data?'business':'structure',reason:identity?'identity':account?'account':number?'number':data?'record':'fixed',sample});
  }else if(node.type==='el'){
   if(node.candidate){const business=['field','aggregate'].includes(node.candidate.kind);result.push({path,category:business?'business':'structure',reason:business?node.candidate.kind==='field'?'geometry':'chart':node.candidate.kind==='directive'?'directive':'repeat',sample:business?JSON.stringify(node.style??{}):''});}
   const isTotal=total||node.cls?.includes('total-row')===true;
   const inRecord=node.tag==='button'||node.tag==='th'?false:record||node.tag==='td'&&!isTotal;
   node.children.forEach((child,index)=>walk(child,[...path,'children',index],node.cls?.includes('avatar')??false,inRecord,isTotal));
  }else if(node.type==='repeat'){walk(node.item,[...path,'item']);walk(node.empty,[...path,'empty']);}
 };
 walk(root,[]);return result;
}
/** Conservative local rules on prototype values only. They propose candidates, never a binding. */
export function detectPrototypeValues(root:TemplateNode,messages:Record<string,Record<string,string>>):number {
 let added=0;
 const text=(node:TemplateNode)=>node.type==='text'?(node.i18n?messages[node.i18n]?.fr??'':node.token??''):'';
 const visit=(node:TemplateNode,unit=false,avatar=false):void=>{
  if(node.type==='text'&&!node.candidate){const value=text(node).trim();if(/\b[Ff]oyer\s+\p{Lu}[\p{L}-]+/u.test(value)||avatar&&/^[\p{Lu}]{1,3}$/u.test(value)||unit&&/\d/.test(value)){node.candidate={kind:'field',status:'unbound'};added++;}}
  if(node.type==='el'){const localUnit=node.children.some(child=>/CHF|EUR|USD|€|%|\bans\b|\bmois\b/.test(text(child)));for(const child of node.children)visit(child,unit||localUnit,node.cls?.includes('avatar')??false);}
  if(node.type==='repeat'){visit(node.item);visit(node.empty);}
 };
 visit(root);
 for(const review of reviewPrototypeCandidates(root,messages)){
  let node:unknown=root;for(const key of review.path)node=(node as Record<string|number,unknown>)[key];
  const target=node as TemplateNode;
  if(target.type!=='text')continue;
  if(review.category==='structure')delete target.candidate;
  else if(!target.candidate){target.candidate={kind:'field',status:'unbound'};added++;}
 }
 return added;
}
